var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: {
          "container-class": "my-2 whodas-title",
          content:
            "Resultados obtenidos en el instrumento por dominio WHODAS 2.0",
          icon: "fas fa-file",
          reverse: ""
        }
      }),
      _c("levels", { attrs: { value: _vm.levels } }),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("section-title", {
            attrs: {
              content:
                "Los resultados obtenidos por el evaluado son los siguientes:",
              "has-line": ""
            }
          }),
          _vm._l(_vm.areasByEvaluatedResults, function(item) {
            return _c(
              "div",
              { key: item.area.id },
              [
                _c("answer", {
                  attrs: {
                    "is-read-only": _vm.isReadOnly,
                    levels: _vm.levels,
                    value: item
                  },
                  on: {
                    input: function($event) {
                      return _vm.onAnswer(item, $event)
                    }
                  }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "my-3" },
        [
          _c("label", { staticClass: "data-name" }, [
            _vm._v(" El perfil del evaluado refleja lo siguiente: ")
          ]),
          _c("custom-text-area", {
            attrs: {
              "count-classes": ["d-block", "small-counter"],
              disabled: _vm.isReadOnly,
              maxlength: 3000,
              "show-char-count": ""
            },
            model: {
              value: _vm.model.comment,
              callback: function($$v) {
                _vm.$set(_vm.model, "comment", $$v)
              },
              expression: "model.comment"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c("section-title", {
            attrs: {
              content:
                "Códigos de la CIF representados en los hallazgos del WHODAS:",
              "has-line": ""
            }
          }),
          _vm._l(_vm.areasByWhodasCifCodes, function(item) {
            return _c(
              "div",
              { key: item.area.id },
              [
                _c("answer", {
                  attrs: { "is-read-only": _vm.isReadOnly, value: item },
                  on: {
                    input: function($event) {
                      return _vm.onAnswer(item, $event)
                    }
                  }
                })
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }